














import AppSidebar from '@/components/partial/AppSidebar.vue';
import AuthPromp from '@/components/container/AuthPromp.vue';
import AppNotifications from '@/components/partial/AppNotifications.vue';
import AppBar from '@/components/partial/AppBar.vue';
import { computed, defineComponent, provide, ref } from '@vue/composition-api';
export const authSym = Symbol();
export const notifSym = Symbol();
export default defineComponent({
  components: { AuthPromp, AppSidebar, AppNotifications, AppBar },
  setup(_, { refs }) {
    const authPrompt = computed(() => refs.authPromp);
    const notify = computed(() => refs.notify);
    provide(authSym, authPrompt);
    provide(notifSym, notify);
  },
});
